import React, { Dispatch, SetStateAction } from "react";
import {
  Button,
  FieldError,
  Form,
  Input,
  Label,
  TextField,
} from "@heroui/react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "@tanstack/react-router";
import { Icon } from "@iconify/react";

import { authClient } from "@/shared/auth";

interface IFormInput {
  code: string;
}

type CodeAuthCardProps = {
  phone: string;
  setPhone: Dispatch<SetStateAction<string | undefined>>;
};

export const CodeAuthCard = ({ phone, setPhone }: CodeAuthCardProps) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  const sess = authClient.useSession();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<IFormInput>();

  function resendCode() {
    authClient.phoneNumber.sendOtp({
      phoneNumber: phone,
    });
  }

  const onSubmit: SubmitHandler<IFormInput> = ({ code }) => {
    setIsLoading(true);
    authClient.phoneNumber
      .verify({
        phoneNumber: phone,
        code,
        disableSession: false,
      })
      .then(async () => {
        await sess.refetch();
        navigate({ to: "/dashboard" });
      })
      .catch((error) => {
        setError("code", { type: "server", message: error });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="w-[386px] h-[400px] pr-6">
      <div className="flex flex-col gap-3 pt-8 pb-0">
        <div className="flex flex-row items-center gap-2 w-full">
          <Button
            isIconOnly
            className="font-medium text-sm"
            size="sm"
            variant="ghost"
            onPress={() => setPhone(undefined)}
          >
            <Icon className="size-6" icon="ion:chevron-back" />
          </Button>

          <h1 className="text-2xl font-semibold text-[#212121]">СМС код</h1>
        </div>
        <p className="text-[#212121]">
          Мы отправили 6 значный код по смс на номер {phone}
        </p>
      </div>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="gap-4 mt-11 w-full">
          <TextField isInvalid={!!errors.code?.message}>
            <Label className="text-[#571B23]">Код</Label>
            <Input
              className="bg-white shadow-none"
              disabled={isLoading}
              type="number"
              {...register("code", {
                required: "Укажите cмс код",
              })}
            />
            <FieldError>{errors.code?.message}</FieldError>
          </TextField>

          <Button
            className="w-full font-medium h-12 bg-[#571B23] mt-12"
            variant="primary"
            isPending={isLoading}
            type="submit"
          >
            Продолжить
          </Button>

          <Button
            className="w-full font-medium h-12 text-[#9E9E9E] mt-6"
            variant="ghost"
            onPress={resendCode}
          >
            Переотправить код
          </Button>
        </div>
      </Form>
    </div>
  );
};
